export const initWix = () => {

    initializeWixGlobalVariables();

    // Create and insert the Access-Pro div
    const accessProDiv = document.createElement('div');
    accessProDiv.id = 'Access-Pro';
    document.body.appendChild(accessProDiv);

    // Create and insert the acp-icon div
    const acpIconDiv = document.createElement('div');
    acpIconDiv.id = 'acp-icon';
    document.body.appendChild(acpIconDiv);

    // Create and insert the acp-widget div with a class
    const acpWidgetDiv = document.createElement('div');
    acpWidgetDiv.id = 'acp-widget';
    acpWidgetDiv.classList.add('asw-menu');
    document.body.appendChild(acpWidgetDiv);

    // Additional elements

    // acp-definition-popup
    const definitionPopup = document.createElement('div');
    definitionPopup.id = 'acp-definition-popup';
    document.body.appendChild(definitionPopup);

    // acp-dictionary-toast
    const dictionaryToast = document.createElement('div');
    dictionaryToast.id = 'acp-dictionary-toast';
    dictionaryToast.className = 'asw-text-speech-bar';
    dictionaryToast.style.display = 'none';
    dictionaryToast.setAttribute('data-ap-translate', 'DICTIONARY DESC');
    dictionaryToast.innerText = 'Double click the content to see meaning';
    document.body.appendChild(dictionaryToast);

    // acp-virtualKeyboardPopup
    const virtualKeyboardPopup = document.createElement('div');
    virtualKeyboardPopup.id = 'acp-virtualKeyboardPopup';
    virtualKeyboardPopup.setAttribute('role', 'dialog');
    virtualKeyboardPopup.setAttribute('aria-modal', 'true');
    virtualKeyboardPopup.setAttribute('aria-label', 'Virtual keyboard popup');

    // Close button with SVG
    const closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Close virtual keyboard');
    closeBtn.id = 'acp-closeKeyboardBtn';
    closeBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    virtualKeyboardPopup.appendChild(closeBtn);

    // Virtual keyboard container
    const keyboardDiv = document.createElement('div');
    keyboardDiv.id = 'acp-virtual-keyboard';
    keyboardDiv.className = 'simple-keyboard';
    virtualKeyboardPopup.appendChild(keyboardDiv);

    document.body.appendChild(virtualKeyboardPopup);

    // Make the keyboard draggable
    function makeDraggableVirtualKeyboard(el) {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        el.onmousedown = dragMouseDown;

        function dragMouseDown(e) {
            e.preventDefault();
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e.preventDefault();
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            el.style.top = el.offsetTop - pos2 + 'px';
            el.style.left = el.offsetLeft - pos1 + 'px';
            el.style.bottom = 'unset';
            el.style.right = 'unset';
        }

        function closeDragElement() {
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    makeDraggableVirtualKeyboard(virtualKeyboardPopup);
}

/**
 * Resolve store hash from data-aswid, or from main.js?instance= (Script Manager).
 */
export const aswGetInstanceId = () => {
    const scriptElement = document.getElementById('aswWidgetScript');
    const fromAttr = scriptElement?.getAttribute('data-aswid');
    if (fromAttr) return fromAttr;

    try {
        const scripts = document.getElementsByTagName('script');
        for (let i = scripts.length - 1; i >= 0; i -= 1) {
            const src = scripts[i].src || '';
            if (!/main\.js(\?|$)/.test(src)) continue;
            const url = new URL(src);
            const instance = url.searchParams.get('instance') || url.searchParams.get('store_hash');
            if (instance) return instance;
        }
    } catch (_) {
        // ignore malformed script src
    }

    return null;
};

const initializeWixGlobalVariables = () => {
    const appUrl = process.env.APP_URL;
    window.accessProProxyHandle = `${appUrl}/api/v1`;
    window.accessProStaticPath = `${appUrl}/static/extension`;

    // Prefer store_hash so multi-storefront channel hostnames still resolve.
    const instanceId = aswGetInstanceId();
    const params = new URLSearchParams();
    if (instanceId) params.set('store_hash', instanceId);
    params.set('domain', window.location.hostname);
    window.accessProSettingsUrl = `${window.accessProProxyHandle}/widget-settings?${params.toString()}`;
    window.accessProPageViewsCountUrl = `${window.accessProProxyHandle}/theme/pageviews-update`;

    window.shopify_domain = `https://${window.location.hostname}`;
    window.accessProTranslationUrl = `https://access-pro-api.entanglecommerce.com/api/v1/language/translate/?domain=${window.shopify_domain}`;

    window.pageViewsCountURL = `${window.accessProProxyHandle}/theme/pageviews-update`;
}

